import hero_img from './hero_img.png'
import cart_icon from './cart_icon.png'
import bin_icon from './bin_icon.png'
import dropdown_icon from './dropdown_icon.png'
import exchange_icon from './exchange_icon.png'
import profile_icon from './profile_icon.png'
import quality_icon from './quality_icon.png'
import search_icon from './search_icon.png'
import star_dull_icon from './star_dull_icon.png'
import star_icon from './star_icon.png'
import support_img from './support_img.png'
import menu_icon from './menu_icon.png'
import about_img from './about_img.png'
import contact_img from './contact_img.png'
import razorpay_logo from './razorpay_logo.png'
import stripe_logo from './stripe_logo.png'
import cross_icon from './cross_icon.png'
import redlight from './redhighlight.png'
import shoeHead1 from './shoe1.png'
import shoeHead2 from './shoe2.png'
import shoeHead3 from './shoe3.png'
import shoeHead4 from './shoe4.png'
import mainShoe from './shoe5.png'
import gredBack from './gredBack.png'
import nike from './nike.png'
import addidas from './addidas.png'
import jorden from './jorden.png'
import vans from './vans.png'
import newbal from './newbal.png'
import fstar from './Fstar.png'
import hstar from './Hstar.png'
import arrow from './arrowIcon.svg'
import user1 from './user1.jpg'
import user2 from './user2.jpg'
import user3 from './user3.jpg'
import mainIMG from './mainIMG.png'
import contactUS from './contactUS.webp'
import aboutus2 from './aboutus2.png'
import newCont from './conteactUSNew.jpg'
import facebook from './facebook.png'
import google from './google.png'


export const assets = {
  hero_img,
  cart_icon,
  dropdown_icon,
  exchange_icon,
  profile_icon,
  quality_icon,
  search_icon,
  star_dull_icon,
  star_icon,
  bin_icon,
  support_img,
  menu_icon,
  about_img,
  contact_img,
  razorpay_logo,
  stripe_logo,
  cross_icon,
  redlight,
  shoeHead1,
  shoeHead2,
  shoeHead3,
  shoeHead4,
  mainShoe,
  gredBack,
  nike, addidas, jorden, newbal, vans, fstar, hstar, arrow, user1, user2, user3, mainIMG, contactUS, aboutus2, newCont, facebook, google
}

export const testimonials = [
  {
    name: "John Thompson",
    image: user1,
    stars: 5,
    description: "I absolutely love my new sneakers from TrendHive! They are incredibly comfortable and stylish, making them perfect for my daily runs and casual outings. I've received so many compliments, and I couldn't be happier with my purchase!",
  },
  {
    name: "Michael white",
    image: user2,
    stars: 5,
    description: "TrendHive's dress shoes are a game-changer! I wore them to a wedding, and not only did they look amazing, but they were also surprisingly comfortable all night long. I'll definitely be coming back for more styles!",
  },
  {
    name: "Danial Rodriguez",
    image: user3,
    stars: 4,
    description: "I bought a pair of kids' sports shoes for my son, and he loves them! They fit perfectly, are easy to put on, and withstand all his outdoor adventures. It's great to find a brand that combines style and durability for kids!",
  },
];


export const mailBodyTemp = `<!DOCTYPE html>
<html lang="en" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="x-apple-disable-message-reformatting">
    <meta name="format-detection" content="telephone=no,address=no,email=no,date=no,url=no">
    <meta name="color-scheme" content="light">
    <meta name="supported-color-schemes" content="light">
    <title></title>
   
    <style>
      :root {
      color-scheme: light;
      supported-color-schemes: light;
      }
      html,
      body {
      margin: 0 auto !important;
      padding: 0 !important;
      height: 100% !important;
      width: 100% !important;
      }
      body {
      background-color: #f2f2f2;
      }
      div[style*="margin: 16px 0"] {
      margin: 0 !important;
      }
      table,
      td {
      mso-table-lspace: 0pt !important;
      mso-table-rspace: 0pt !important;
      }
      table {
      border-spacing: 0 !important;
      border-collapse: collapse !important;
      table-layout: fixed !important;
      margin: 0 auto !important;
      mso-table-lspace: 0;
      mso-table-rspace: 0;
      }
      h2,
      h3 {
      padding: 0;
      margin: 0;
      border: 0;
      background: none;
      }
    </style>
 
      <style>
      a[x-apple-data-detectors] {
      color: inherit !important;
      text-decoration: none !important;
      font-size: inherit !important;
      font-family: inherit !important;
      font-weight: inherit !important;
      line-height: inherit !important;
      }
      [x-apple-data-detectors-type="calendar-event"] {
      color: inherit !important;
      -webkit-text-decoration-color: inherit !important;
      text-decoration: none !important;
      }
      </style>
 
    <style>
      ul {
      padding-left: 17px;
      }
      ol {
      padding-left: 20px;
      }
    </style>
  </head>
  <body style="margin: 0; padding: 0 !important; mso-line-height-rule: exactly;background-color: #202020;">
    <center role="article" aria-roledescription="email" aria-label="email name" lang="en" dir="ltr" style="width: 100%;background-color: #202020;">
     
            <div style="display: none; font-size: 1px; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; mso-hide: all; font-family: Trebuchet MS,Arial,sans-serif;" aria-hidden="true">
              pre-header
            </div>
            <div style="display: none; font-size: 1px; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; mso-hide: all; font-family: sans-serif;">&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;</div>
            <div style="max-width: 680px; margin: 0 auto;">
              
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin: auto;">
                      <tr>
                        <td background="https://res.cloudinary.com/dccfz1y2k/image/upload/v1728939985/u9jdvep3cv3xnmdo2rcz.png" bgcolor="#646464" align="center" style="text-align: center; background-position: center center !important; background-repeat:no-repeat !important; background-size: cover !important;">
                        
                          <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="width:100%;">
                            <tr>
                              <td align="center" style="font-size:0;text-align:right;">
                                
                                  <div style="border:50px solid transparent;border-right-color:#fff;border-top-color:#fff;display:inline-block;margin:0;vertical-align: bottom"></div>
                                  <div style="display:inline-block;margin:0;padding:0; width:150px; height:80px;background-color:#fffffe;vertical-align:top;font-family: Trebuchet MS,Arial,sans-serif; font-size:14px; mso-line-height-rule: exactly;line-height:150%;color: #000001;text-align:left;background-color:#fffffe;padding:10px;max-width:200px;">
                                  <p style="margin-right:20px;font-size:50px;font-family:'Brush Script MT',cursive;color:voilet">trendHive</p>
                                  </div>
                              </td>
                            </tr>
                            <tr>
                              <td align="center" style="text-align: center;padding:85px 0">
                                
                                    <h1 style="margin:0;font-family: 'Segoe UI','Roboto','Helvetica Neue',Arial,sans-serif;color: #fffffe;font-size: 32px;font-weight: 400;">
                                      Step Into Style - Discover Your Perfect Pair
                                    </h1>
                                  
                              </td>
                            </tr>
                            <tr>
                              <td align="left" style="font-size:0">
                               
                                  <div style="display:inline-block;margin:0;padding:0; width:150px; height:80px;background-color:#fffffe;vertical-align:top;font-family: Trebuchet MS,Arial,sans-serif; font-size:14px; mso-line-height-rule: exactly;line-height:150%;color: #000001;text-align:left;padding:10px;max-width:200px;background-color:#fff">
                                  <p style="margin:0">Join Now & Enjoy 20% Off Your First Purchase!</p>
                                  </div>
                                  <div style="border:50px solid transparent;border-left-color:#fff;border-bottom-color:#fff;display:inline-block;margin:0;vertical-align: bottom"></div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td aria-hidden="true" height="20" style="background-color:#fffffe;font-size: 0px; line-height:20px;height:20px;">
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td style="background-color:#fffffe;padding-top:30px;padding-left:10px;padding-right:10px;padding-bottom:10px;text-align:left">
                         
                                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                  <tr>
                                    <td style="padding: 10px;font-family: 'Arial', sans-serif;font-size:14px;mso-line-height-rule: exactly; line-height: 21px;color:#0C2340;">
                                      <p style="margin:0;">
                                        <strong>Hey there,<span style="color:#525ca3"></span>
                                        </strong>
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="padding:10px; font-family: Arial, sans-serif; font-size:14px; mso-line-height-rule: exactly;line-height: 21px; color: #0C2340;text-align:left">
                                      <p style="margin:0">Welcome to TrendHive, where style meets comfort! We're thrilled to have you here. As a special thank you for joining our community, we're giving you 20% off your first purchase.🎉 Whether you're looking for the latest in casual sneakers, formal dress shoes, or sporty kicks, we've got something for everyone.</p>
                                      
                                      <p style="margin:0">Simply use the code WELCOME20 at checkout and enjoy your discount! 😀</p>
                                      
                                      <p style="margin:0">Don't wait—your perfect pair is just a click away!
[Shop Now]</p>
                                      We can't wait to see you step into style with TrendHive!

                                      <p>Best,
                                      </p>
                                      <p>The TrendHive Team</p>
                                    </td>
                                  </tr>
                                </table>
                                
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 10px;background-color:#fffffe;">
                          <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin: auto;">
                            <tr>
                              <td style="border-radius: 30px; background: #F8485E;text-align:center">
                                <a href="https://trendhive.vercel.app/collection" style="border: 1px solid #F8485E; font-family: Arial,sans-serif; font-size:14px; mso-line-height-rule: exactly;line-height: 14px; text-decoration: none; padding: 10px 31px; color: #fffffe; font-weight:bold;display: block; border-radius: 30px;">
                                <strong>Visit Now</strong>
                                </a>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top" style="font-size:0; padding: 10px; background-color:#fffffe;">
                        
                                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                  <tr>
                                    <td style="padding:10px; font-family: Arial, sans-serif; font-size:14px; mso-line-height-rule: exactly;line-height: 21px; color: #0C2340;text-align:left">
                                      <p style="margin:0">P.S. This offer is only valid for a limited time, so don't miss out! 🏃
                                      </p>
                                      <p>This keeps the tone friendly, exciting, and action-oriented.</p>
                                    </td>
                                  </tr>
                                </table>
                                
                        </td>
                      </tr>
                      
                    </table>
                    
                  </td>
                </tr>
              </table>
              
            </div>
          </td>
        </tr>
      </table>
    </center>
  </body>
</html>`;